import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import ActivityLogList from './ActivityLogList';

function TablePage(props) {
  return (
    <ScopedCssBaseline>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <ActivityLogList />
      </Box>
    </ScopedCssBaseline>
  );
}

export default TablePage;
